import View from './View';
import schema from './schema';
import icon from '@plone/volto/icons/megaphone.svg';

const CallToActionBlock = {
  id: 'call_to_action',
  title: 'Call To Action',
  icon: icon,
  group: 'castle',
  view: View,
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: schema,
};

export default CallToActionBlock;